import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { formatDate } from '@angular/common';
import { NgForm, NgModel } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GapService } from '../../api/services/gap/gap.service';
import { GlobalService } from '../../api/services/global/global.service';
import { GapQuoteDetail } from '../../api/models/gap-quote-detail';
import { QuoteStatus } from '../../enums/quote-status.enum';
import { ResendRequest } from '../../api/models/resend-request';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

declare let jQuery: any;
declare let jcf: any;

@Component({
  selector: 'app-view-quote-details',
  templateUrl: './view-quote-details.component.html',
  styleUrls: ['./view-quote-details.component.css'],
})
export class ViewQuoteDetailsComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  quoteId: string;
  quote: GapQuoteDetail;
  emailAddress = '';
  pdfBlob: any;
  pdfUrl: any;
  downloadUrl: any;
  emailResponse = false;
  success = false;
  disableButton = false;
  showSpinner = false;
  todayDate: string;
  statusMessage = '';
  submitAttempted = false;

  constructor(
    private gapService: GapService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}
  @ViewChild('resendForm') resendForm: NgForm;
  @ViewChild('emailModel') emailModel: NgModel;

  protected readonly QuoteStatus = QuoteStatus;

  ngOnInit() {
    this.globalService.scrollToTop();
    this.blockUI.start();
    this.quoteId = this.route.snapshot.paramMap.get('id');
    this.retrievePdf(this.quoteId);
    this.quote = this.globalService.gapQuoteDetailsResponse.QuoteDetails.find(
      (quote) => quote.quoteID === this.quoteId
    );

    if (this.quote.clientEmail) {
      this.emailAddress = this.quote.clientEmail;
    }

    this.todayDate = formatDate(new Date(), 'dd-MM-yyyy', 'en-ZA');
  }

  retrievePdf(id: string): void {
    this.gapService.retrievePdfQuote(id).subscribe(response => {
      this.pdfBlob = response;
      window.URL = window.URL || (window as any).webkitUrl;
      this.downloadUrl = window.URL.createObjectURL(response);
      this.pdfUrl = this.downloadUrl;
      this.transform(this.pdfUrl);
      this.reloadJcf();
      this.blockUI.stop();
    });
  }

  resendQuote(): void {
    this.submitAttempted = true;

    if (this.emailModel) {
      this.emailModel.control.markAsTouched();
    }

    if (!this.emailAddress || (this.emailModel && this.emailModel.invalid)) {
      return;
    }

    this.disableButton = true;
    this.showSpinner = true;
    this.emailResponse = false;

    const resendRequest: ResendRequest = {
      emailAddress: this.emailAddress,
      quoteRefNumber: this.quote.quoteID,
      firstName: this.quote.clientName,
      lastName: this.quote.clientSurname,
    };

    this.gapService.resendEmail(resendRequest).subscribe({
      next: (response) => {
        this.success = response.success;
        this.emailResponse = true;
        if (response.success) {
          this.statusMessage = `Sent successfully to ${this.emailAddress} on ${this.todayDate}.`
          const quoteToUpdate = this.globalService.gapQuoteDetailsResponse.QuoteDetails.find(
            (q) => q.quoteID === this.quote.quoteID
          );
          if (quoteToUpdate) {
            quoteToUpdate.quoteStatuses = response.quoteStatuses;
          }
        } else {
          this.statusMessage = `Failed to send to ${this.emailAddress} on ${this.todayDate}.`
        }
      },
      error: (err) => {
        console.error(err);
        this.success = false;
        this.emailResponse = true;
        this.statusMessage = `Failed to send to ${this.emailAddress} on ${this.todayDate}.`
      },
      complete: () => {
        this.disableButton = false;
        this.showSpinner = false;
      },
    });
  }

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  download() {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(this.pdfBlob, 'Discovery Health Gap - ' + this.quoteId + '.pdf');
    } else {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = this.downloadUrl;
      a.download = 'Discovery Health Gap - ' + this.quoteId + '.pdf';
      a.target = '_blank';
      a.click();
      window.URL.revokeObjectURL(this.downloadUrl);
      a.remove();
    }
  }

  reloadJcf() {
    jQuery(function () {
      jcf.replaceAll();
    });
  }

  reset() {
    this.emailAddress = this.quote.clientEmail || '';
    this.emailResponse = false;
    this.success = false;
    this.disableButton = false;
    this.showSpinner = false;
    this.submitAttempted = false;
    this.quote = this.globalService.gapQuoteDetailsResponse.QuoteDetails.find(
      (quote) => quote.quoteID === this.quoteId
    );

    if (this.resendForm) {
      this.resendForm.resetForm({
        emailAddress: this.emailAddress || ''
      });
    }
  }
}
